import i18n from 'i18next';

export const redirectToTrustpilot = () => {
  window.open(i18n.t('redirect_to_trustpilot_url'), '_blank');
};
